export default __webpack_public_path__ + "static/image1-1fd2be3e625e6526f9a5c448d1d437ef.gif";